/** @graphql cc **/
import gql from 'graphql-tag';

export const ReadTimeQuery = gql`
	query ReadTimeQuery($contentId: ID, $status: [String]) {
		content(id: $contentId, status: $status) {
			nodes {
				id
				type
				body {
					dynamic {
						value
						representation
					}
				}
				operations {
					operation
					targetType
				}
				history {
					createdBy {
						type
						... on KnownUser {
							accountId
						}
						... on User {
							accountId
						}
					}
				}
			}
		}
	}
`;
